import { useCallback } from 'react'

import { Box, Divider, Stack } from "@mui/material"

import { ColumnSplitter } from 'components/controls/splitter'
import { Loading } from 'components/controls/loading'
import { ErrorBlock } from 'components/controls/errorInfo'
import { SearchWordField } from 'components/controls/searchWordField'

import { SisetuResult } from "interface/sisetu"

import { useSisetuPreview } from '../../container'

import { useSisetusTrialPage } from './container'
import { TrialList } from './components/trialList'
import { PersonsTable } from './components/personsTable'
import { TrialBarGraph } from './components/trialBarGraph'

type SisetuPreviewTrialPageProps = {
  sisetu: SisetuResult
  container: ReturnType<typeof useSisetuPreview>
}
export const SisetuPreviewTrialPage = ({
  sisetu,
  container: {
    onTrialOpen
  }
}: SisetuPreviewTrialPageProps) => {
  const container = useSisetusTrialPage({ sisetuCode: sisetu.sisetuCode })
  const {
    searchWord, setSearchWord,
		selectedYear, setSelectedYear,
		selectedPerson, setSelectedPerson,
		loading, error,
		trials, persons, yearsStats
  } = container

  const onSelectedTrial = useCallback(
    (trialId: number) => {
      const trial = trials.find(trial => trial.trialId === trialId)
      if (!trial) return
      onTrialOpen(trial, trials)
    },
    [onTrialOpen, trials]
  )
  return (
    <>
      {loading ? <Loading/> :
       error ? <ErrorBlock error={error} padding={1}/> : (
        <ColumnSplitter initialSizes={[66, 34]}>
          <Stack
            direction='column'
            height='100%'
            position='relative'
            overflow='hidden'
          >
            <Stack
              direction="column"
              flexShrink={0}
              spacing={1}
              padding={1}
            >
              <Stack
                flexShrink={0}
                overflow="hidden"
                direction="row"
                justifyContent="center"
              >
                <Box width="100%" maxWidth={"40rem"}>
                  <TrialBarGraph
                    yearsStats={yearsStats}
                    selectedYear={selectedYear}
                    setSelectedYear={setSelectedYear}
                    height={80}
                  />
                </Box>
              </Stack>
            </Stack>

            <Divider/>

            <PersonsTable
              flexGrow={1}
              overflow='hidden'
              persons={persons}
              selectedPerson={selectedPerson}
              setSelectedPerson={setSelectedPerson}
            />
          </Stack>

          <Stack
            direction='column'
            height='100%'
            overflow='hidden'
          >
            <Box
              flexShrink={0}
              padding={1}
            >
              <SearchWordField
                id='search-word-trial'
                searchWord={searchWord}
                onChangeSearchWord={setSearchWord}
                fullWidth
              />
            </Box>
            <Divider/>
            <Box
              flexGrow={1}
              overflow='auto'
              position='relative'
            >
              <TrialList
                trials={trials}
                onSelChangeTrial={onSelectedTrial}
              />
            </Box>
          </Stack>
        </ColumnSplitter>
      )}
    </>
  )
}